<template>
    <div>
        <nav-header></nav-header>
        <div class="editparameters-form validate-form p-l-50 p-r-50 p-t-10 p-b-80" >
            <section>
                <div class="page-title">
                    <h2>Configurar Parâmetros de Controle</h2>
                </div>
                <hr/>
                <div>
                    <h3>{{nome_empresa}}</h3>
                </div><br>
                <div class="wrap-form-fields" style="align: center">
                    <label class="label-input">Custo por Documento:</label>
                    <b-input-group prepend="R$">
                        <b-form-input v-model="costPerReq" type="text" v-on:keyup="formatMoney" class="input-field"></b-form-input>
                    </b-input-group>
                </div>
                <button class="btn btn-secondary" v-on:click="$router.push({name:'companyManagement'})" style="aling: left; margin-left: 10px">Cancelar</button>
                <button class="btn btn-primary" v-on:click="this.updateParameters" style="aling: left">Confirmar</button>
            </section>
        </div>
        <user-profile-footer></user-profile-footer>
    </div>
</template>

<style scoped src="@/assets/css/util.css">
</style>

<script>
    import axios from 'axios';
    import config from '../helpers/generalConfig';
    import NavHeader from "../components/NavHeader.vue";
    import UserProfileFooter from '../components/UserProfileFooter.vue';
    
    export default {
        components: { NavHeader, UserProfileFooter },

        data(){
            return {
                id: this.$route.params.companyId,
                nome_empresa: '',
                costPerReq: '0,00',
            }
        },

        created(){
            this.getParameters();  
        },

        methods: { 
            getParameters(){
                axios.get(`${config.jsonServer}/company/${this.id}`, 
                    this.headers()
                )
                .then(response => {
                    this.nome_empresa = response.data.nome_empresa;
                    this.maxReq = response.data.maximo_requisicoes;
                    this.expirationPeriod = response.data.dias_expiracao_chave_api;
                    this.costPerReq = response.data.custo_requisicao.replace('.',',').replace('$','');
                })
                .catch((err) => {
                    if(err.response){
                        this.$bvToast.toast(err.response.data.message, {
                        title: 'Erro ao buscar parâmetros',
                        variant: 'danger',
                        solid: true
                        });
                    }
                });
            },

            updateParameters() {
                axios.put(`${config.jsonServer}/company/update`, {
                    id_empresa: this.id,
                    maximo_requisicoes: this.maxReq,
                    dias_expiracao_chave_api: this.expirationPeriod,
                    custo_requisicao: this.costPerReq.replace(',','.')
                }, this.headers())
                .then( () => {
                    this.$root.$bvToast.toast("Parâmetros atualizados!", {
                        title: 'Sucesso',
                        variant: 'success',
                        solid: true
                    });
                    this.$router.push('/companyManagement');
                })
                .catch( (err) =>{
                    if(err.response){
                        this.$bvToast.toast(err.response.data.message, {
                        title: 'Nenhum resultado encontrado',
                        variant: 'danger',
                        solid: true
                        });
                    }
                });
            },

            headers() {
                const token = this.$store.getters['auth/token'].token
                const headers = { headers: { Authorization: 'Bearer ' + token }}
                return headers;
            },

            formatMoney() {
                var value = this.costPerReq;

                value = value + '';
                value = parseInt(value.replace(/[\D]+/g, ''));
                value = value + '';
                value = value.replace(/([0-9]{2})$/g, ",$1");

                this.costPerReq = value;
                if(value == 'NaN') this.costPerReq = '';
            }
        }
    }
</script>